import { Component } from '@angular/core';

@Component({
  selector: 'ov-suite-app-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent {}
